/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewempty2Inputs */

const en_sharereviewempty2 = /** @type {(inputs: Sharereviewempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to review.`)
};

const de_sharereviewempty2 = /** @type {(inputs: Sharereviewempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts zu prüfen.`)
};

/**
* | output |
* | --- |
* | "Nothing to review." |
*
* @param {Sharereviewempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewempty2 = /** @type {((inputs?: Sharereviewempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewempty2(inputs)
	return de_sharereviewempty2(inputs)
});
export { sharereviewempty2 as "shareReviewEmpty" }